(function (window) {
  "use strict";

  const { origin, pathname } = window.location;

  // Extract `/websites/{client-slug}` for local dev environment
  // Example:
  // /websites/karen-taylor-fine-art/page/1
  // → /websites/karen-taylor-fine-art
  //
  // On production (no /websites/ prefix), use just the origin
  // so all pages on the site share the same localStorage namespace
  let sitePath = "";

  const match = pathname.match(/^\/websites\/[^/]+/);

  if (match) {
    sitePath = match[0];
  }

  const PREFIX = origin + sitePath + "::";

  const siteStorage = {
    _rawGet(key) {
      return window.localStorage.getItem(key);
    },

    _rawSet(key, value) {
      window.localStorage.setItem(key, value);
    },

    key(key) {
      return PREFIX + key;
    },

    get(key, fallback = null) {
      try {
        const value = this._rawGet(this.key(key));
        return value !== null ? JSON.parse(value) : fallback;
      } catch (err) {
        console.warn("[siteStorage] get failed:", err);
        return fallback;
      }
    },

    set(key, value) {
      try {
        this._rawSet(this.key(key), JSON.stringify(value));
      } catch (err) {
        console.warn("[siteStorage] set failed:", err);
      }
    },

    remove(key) {
      window.localStorage.removeItem(this.key(key));
    },

    clearSite() {
      Object.keys(window.localStorage).forEach((k) => {
        if (k.startsWith(PREFIX)) {
          window.localStorage.removeItem(k);
        }
      });
    },
  };

  window.siteStorage = siteStorage;
})(window);
